import Main from '../views/main/main.vue'
import comIndex from '@/views/ywgl/comIndex'
import comuserIndex from '@/views/ywgl/comuserIndex'
import comTypeCheckIndex from '@/views/ywgl/comTypeCheckIndex'
import comTypeApplyIndex from '@/views/ywgl/comTypeApplyIndex'
import comTypeApplyForm from '@/views/ywgl/comTypeApplyForm'
import cosItemForm from '@/views/ywgl/cosItemForm'
import comTypeForm from '@/views/ywgl/comTypeForm'
import comMenuForm from '@/views/ywgl/comMenuForm'
import wmenuIndex from '@/views/ywgl/wmenuIndex'
import carfigIndex from '@/views/ywgl/carfigIndex'
import carfigForm from '@/views/ywgl/carfigForm'
import womIndex from '@/views/ywgl/womIndex'
import noticeIndex from '@/views/ywgl/noticeIndex'
import noticeForm from '@/views/ywgl/noticeForm'
import pjnoticeIndex from '@/views/jjgl/pjnoticeIndex'
import pjnoticeForm from '@/views/jjgl/pjnoticeForm'
import friendlinkIndex from '@/views/ywgl/friendlinkIndex'
import friendlinkForm from '@/views/ywgl/friendlinkForm'
import appendForm from '@/views/ywgl/appendForm'
import expertIndex from '@/views/ywgl/expertIndex'
import expertForm from '@/views/ywgl/expertForm'
import expertmenuForm from '@/views/ywgl/expertmenuForm'
import qcmReview from '@/views/ywgl/qcmReview'
import qcmFrom from '@/views/ywgl/qcmFrom'
import pmIndex from '@/views/ywgl/pmIndex'
import pmlbindex from '@/views/ywgl/pmlbindex'
import pmlbform from '@/views/ywgl/pmlbform'
import pfxmIndex from '@/views/ywgl/pfxmIndex'
import pfxmForm from '@/views/ywgl/pfxmForm'
import regCheckIndex from '@/views/ywgl/regCheckIndex'
import ZcApprove from '@/views/ywgl/ZcApprove'
import jjtx from '@/views/ywgl/jjtx'
import pbrIndex from '@/views/ywgl/pbrIndex'
import pbrCenterQuery from '@/views/ywgl/pbrCenterQuery'
export default [{
  path: '/ywgl',
  component: Main,
  redirect: '',
  meta: {
    title: '运维管理',
    icon: 'guide'
  },
  children: [
    {
      path: 'comIndex',
      component: comIndex,
      name: 'comIndex',
      meta: { title: '平台客户', keepAlive: true }
    },
    {
      path: 'comuserIndex',
      component: comuserIndex,
      name: 'comuserIndex',
      meta: { title: '用户管理', keepAlive: true }
    },
    {
      path: 'comTypeForm',
      component: comTypeForm,
      name: 'comTypeForm',
      meta: { title: '设置单位类型', keepAlive: true }
    },
    {
      path: 'comTypeCheckIndex',
      component: comTypeCheckIndex,
      name: 'comTypeCheckIndex',
      meta: { title: '审核角色申请', keepAlive: true }
    },
    {
      path: 'comTypeApplyIndex',
      component: comTypeApplyIndex,
      name: 'comTypeApplyIndex',
      meta: { title: '单位类型管理', keepAlive: true }
    },
    {
      path: 'comTypeApplyForm',
      component: comTypeApplyForm,
      name: 'comTypeApplyForm',
      meta: { title: '角色申请', keepAlive: true }
    },
    {
      path: 'cosItemForm',
      component: cosItemForm,
      name: 'cosItemForm',
      meta: { title: '添加平台成员', keepAlive: true }
    },
    {
      path: 'comMenuForm',
      component: comMenuForm,
      name: 'comMenuForm',
      meta: { title: '菜单授权', keepAlive: true }
    },
    {
      path: 'wmenuIndex',
      component: wmenuIndex,
      name: 'wmenuIndex',
      meta: { title: '网站菜单', keepAlive: true }
    },
    {
      path: 'carfigIndex',
      component: carfigIndex,
      name: 'carfigIndex',
      meta: { title: '网站图片设置', keepAlive: true }
    },
    {
      path: 'carfigForm',
      component: carfigForm,
      name: 'carfigForm',
      meta: { title: '图片设置', keepAlive: true }
    },
    {
      path: 'womIndex',
      component: womIndex,
      name: 'womIndex',
      meta: { title: '网站运维', keepAlive: true }
    },
    {
      path: 'noticeIndex',
      component: noticeIndex,
      name: 'noticeIndex',
      meta: { title: '内容管理', keepAlive: true }
    },
    // {
    //   path: 'changeNoticeForm',
    //   component: import('@/views/ywgl/changeNoticeForm'),
    //   name: 'changeNoticeForm',
    //   meta: { title: '内容发布', keepAlive: true }
    // },
    {
      path: 'noticeForm',
      component: noticeForm,
      name: 'noticeForm',
      meta: { title: '内容发布', keepAlive: true }
    },
    {
      path: 'pjnoticeIndex',
      component: pjnoticeIndex,
      name: 'pjnoticeIndex',
      meta: { title: '公告管理', keepAlive: true }
    },
    {
      path: 'pjnoticeForm',
      component: pjnoticeForm,
      name: 'pjnoticeForm',
      meta: { title: '发布公告', keepAlive: true }
    },
    {
      path: 'friendlinkIndex',
      component: friendlinkIndex,
      name: 'friendlinkIndex',
      meta: { title: '友情链接', keepAlive: true }
    },
    {
      path: 'friendlinkForm',
      component: friendlinkForm,
      name: 'friendlinkForm',
      meta: { title: '友情链接维护', keepAlive: true }
    },
    {
      path: 'appendForm',
      component: appendForm,
      name: 'appendForm',
      meta: { title: '附件维护', keepAlive: true }
    },
    {
      path: 'expertIndex',
      component: expertIndex,
      name: 'expertIndex',
      meta: { title: '评审人资料', keepAlive: true }
    },
    {
      path: 'expertForm',
      component: expertForm,
      name: 'expertForm',
      meta: { title: '评审人资料维护', keepAlive: true }
    },
    {
      path: 'expertmenuForm',
      component: expertmenuForm,
      name: 'expertmenuForm',
      meta: { title: '评审人功能授权', keepAlive: true }
    },
    {
      path: 'qcmReview',
      component: qcmReview,
      name: 'qcmReview',
      meta: { title: '项目初审模板', keepAlive: true }
    },
    {
      path: 'qcmFrom',
      component: qcmFrom,
      name: 'qcmFrom',
      meta: { title: '项目初审模板', keepAlive: true }
    },
    {
      path: 'pmIndex',
      component: pmIndex,
      name: 'pmIndex',
      meta: { title: '采购品目', keepAlive: true }
    },
    {
      path: 'pmlbindex',
      component: pmlbindex,
      name: 'pmlbindex',
      meta: { title: '服务费收费规则', keepAlive: true }
    },
    {
      path: 'pbrIndex',
      component: pbrIndex,
      name: 'pbrIndex',
      meta: { title: '竞价IP监控', keepAlive: true }
    },
    {
      path: 'pbrCenterQuery',
      component: pbrCenterQuery,
      name: 'pbrCenterQuery',
      meta: { title: '竞价查询', keepAlive: true }
    },
    {
      path: 'pmlbform',
      component: pmlbform,
      name: 'pmlbform',
      meta: { title: '设置费率', keepAlive: true }
    },
    {
      path: 'pfxmIndex',
      component: pfxmIndex,
      name: 'pfxmIndex',
      meta: { title: '评分项目', keepAlive: true }
    },
    {
      path: 'pfxmForm',
      component: pfxmForm,
      name: 'pfxmForm',
      meta: { title: '设置评分项目', keepAlive: true }
    },
    {
      path: 'regCheckIndex',
      component: regCheckIndex,
      name: 'regCheckIndex',
      meta: { title: '注册审批', keepAlive: true }
    },
    {
      path: 'ZcApprove',
      component: ZcApprove,
      name: 'ZcApprove',
      meta: { title: '注册审批', keepAlive: true }
    },
    {
      path: 'jjtx',
      component: jjtx,
      name: 'jjtx',
      meta: { title: '竞价提醒', keepAlive: true }
    }
  ]
}]
